import React from 'react';
import { Grid, Row, Col } from '../../utils/bootstrap';
import { Helmet } from 'react-helmet';
import Colors from '../../Colors';
import { ImageLink } from '../../components/CardLink';

const styles = {
  circle: {
    width: 250,
    height: 250,
    borderRadius: '50%',
    backgroundColor: Colors.blue,
    border: `2px solid ${Colors.lightBlue}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    textAlign: 'center',
    padding: 20,
    margin: 20,
  },
  name: {
    color: Colors.lightBlue,
  },
};

class OurTeam extends React.Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { history } = this.props;
    return (
      <div className="our-team">
        <Helmet>
          <title>Our Team | Corporate Advisory | Premium Capital Partners</title>
          <meta name="description" content="The team at Premium Capital Partners is guided by over 50 years’ experience in key roles for globally recognised financial institutions." />
        </Helmet>
        <h1 style={{bottom: 10, right: 10, textAlign: 'right'}}>Corporate advisory</h1>
        <Grid>
          <Row>
            <Col xs={12} style={{ textAlign: 'center' }}>
              <h2 style={{ fontSize: '4em', marginTop: '1em' }}>Our Team</h2>
              <h5 className="our-team__description">
                The team at Premium Capital Partners boast over 50 years' of corporate advisory
                and management experience operating in key roles for globally recognised financial
                institutions.
              </h5>
            </Col>
          </Row>
          <Row style={styles.row}>
            <ImageLink
              md={3}
              sm={6}
              img="/paul-kuan.png"
              header="Paul Kuan"
              body="Director"
              link="/our-team/paul-kuan"
              history={history}
            />
            <ImageLink
              md={3}
              sm={6}
              img="/Ahmad.png"
              header="Ahmad Kamal Sheikh Awab"
              body="Chief Executive Officer (CEO)"
              link="/our-team/ahmad-kamal"
              history={history}
            />
            <ImageLink
              md={3}
              sm={6}
              img="/Chris.png"
              header="Christopher Koh"
              body="Chairman, Supervisory Board"
              link="/our-team/christopher-koh"
              history={history}
            />
            <ImageLink
              md={3}
              sm={6}
              img="/Khoo.png"
              header="Khoo Khay Teik"
              body="Chief Operating Officer (COO)"
              link="/our-team/khoo-khay-teik"
              history={history}
            />
          </Row>
        </Grid>
        <br /><br />
      </div>
    );
  }
}

export default OurTeam;



// WEBPACK FOOTER //
// ./src/screens/OurTeam/OurTeam.js